import { usePortalContainer } from '../PortalContainerContext';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@thinkalpha/ui-core/utils';
import * as React from 'react';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

// Context-aware PopoverPortal
const PopoverPortal = ({ container, ...props }: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Portal>) => {
    const contextContainer = usePortalContainer();
    return <PopoverPrimitive.Portal container={container ?? contextContainer} {...props} />;
};

const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { container?: HTMLElement }
>(({ className, align = 'center', sideOffset = 4, container, ...props }, ref) => (
    <PopoverPortal container={container}>
        <PopoverPrimitive.Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            className={cn(
                // Match Dialog/Select/FloatingPane so popovers opened from inside dialogs
                // render above the dialog overlay and remain interactive.
                'z-sky-high w-72 rounded-lg bg-gray-925 p-4 text-gray-50 shadow-md outline-hidden',
                // Animations
                'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
                'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                className,
            )}
            {...props}
        />
    </PopoverPortal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverAnchor, PopoverTrigger, PopoverContent, PopoverPortal };
